import type { ITeaserBannerProps } from "app/components/banner/TeaserBanner";
import { TeaserBanner } from "app/components/banner/TeaserBanner";

import { BannerWrapper } from "./KeywordsLimitBannerStyledComponents";

type IKeywordsLimitBannerProps = Omit<ITeaserBannerProps, "buttonType" | "subtitle">;
export const KeywordsLimitBanner = (props: IKeywordsLimitBannerProps) => {
    const { buttonIconName, onButtonClick, title, buttonText } = props;
    return (
        <BannerWrapper>
            <TeaserBanner
                title={title}
                buttonText={buttonText}
                buttonType="flat"
                buttonIconName={buttonIconName}
                onButtonClick={onButtonClick}
                CustomIcon={null}
            />
        </BannerWrapper>
    );
};
